import { render, staticRenderFns } from "./ProMember.vue?vue&type=template&id=b8f03596&scoped=true"
import script from "./ProMember.vue?vue&type=script&lang=ts"
export * from "./ProMember.vue?vue&type=script&lang=ts"
import style0 from "./ProMember.vue?vue&type=style&index=0&id=b8f03596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f03596",
  null
  
)

export default component.exports